module.exports = __webpack_public_path__ + "img/147.3ef34787.jpg";